export default __webpack_public_path__ + "static/media/7.325d1b01.svg";